import React from 'react';

import Button from 'components/button/Button';

/**
 * ApiDownloadActions
 *
 * Shared OpenAPI/schema download buttons for the API panel.
 */
const ApiDownloadActions = React.memo(({
  canDownloadOpenApi,
  canDownloadSchema,
  onDownloadOpenApi,
  onDownloadSchema,
  compact = false,
}) => (
  <>
    <Button
      iconKey="download"
      label="OpenAPI JSON"
      enabled={canDownloadOpenApi}
      onClick={onDownloadOpenApi}
    />

    <Button
      iconKey="download"
      label="Download Schema"
      enabled={canDownloadSchema}
      onClick={onDownloadSchema}
    />
  </>
));

ApiDownloadActions.displayName = 'ApiDownloadActions';

export default ApiDownloadActions;
